export const ApiToken = {
  // //! 测试站点
  // token: 'token',
  // url: 'https://www.avevacommunity.com/test/',
  // shareUrl: 'https://www.avevacommunity.com/test/#/',
  // baseApi: 'https://www.avevacommunity.com/testapi/api',
  // channel: 'channel',
  // roadShowId: '10867',
  // trainingWx: '10876', 
  // trainingLs: '10878',
  // trainingForm: 10882,
  // roadShowForm: 10883,
  // workShopId: '10885',
  // paper2023: 10912,
  // paper2025: 10913,
  // e3dPositionId: 10820,//根据用户角色 来判断首页是否展示url带/e3d的链接的内容
  
  //! 正式站点
  token: 'token2',
  url: 'https://www.avevacommunity.com/',
  shareUrl: 'https://www.avevacommunity.com/#/',
  baseApi: 'https://www.avevacommunity.com/api/api',
  channel: 'channel_prod',
  roadShowId: '10870',
  trainingWx: '10900', 
  trainingLs: '10901',
  trainingForm: 10905,
  roadShowForm: 10906,
  workShopId: '10908',
  paper2023: 10960,
  paper2025: 10961,
  e3dPositionId: 10820,
}